import React from 'react';
import { ImpContainer, colors } from '../..';
/**
 * ImpDivider is a simple horizontal divider used to separate content within a layout.
 * It provides customization for width and color and by default has a width of 100% and a height of 1px.
 *
 * @component
 * @example
 * <ImpDivider />
 * <ImpDivider width="50%" color="red" />
 *
 * @param {object} props - The component props.
 * @param {string} [props.width='100%'] - The width of the divider. Defaults to 100% width.
 * @param {string} [props.color='black'] - The color of the divider. Defaults to black.
 *
 * @returns {JSX.Element} The rendered ImpDivider component.
 */
function ImpDivider({ width = '100%', color = colors.border.borderVariant, isLoading = false, }) {
    return (React.createElement(ImpContainer, { width: width, height: "1px", backgroundColor: color, dataTestId: "divider", isLoading: isLoading }));
}
export default ImpDivider;
//# sourceMappingURL=ImpDivider.js.map